import "../App.css";
import FormSpree from "./FormSpree";

export default function HireMe() {
  return (
    <div
      className="modal fade"
      id="hireMe"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="hireMeLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="hireMeLabel">
              Hire Me
            </h1>
            <span
              type="button"
              className="b-0"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="fas fa-x"></i>
            </span>
          </div>
          <div className="modal-body">
            <FormSpree />
          </div>
        </div>
      </div>
    </div>
  );
}
